export const gitInfo = ' (main #0535df6 - 09232026-1533) jorgemariogonza***';
